import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { CustomButtonProps } from 'lib/designSystem/HeaderWithActions';
import PageHeader, { ActionButton } from 'lib/designSystem/PageHeader';
import { formatDateString } from 'lib/functions/utils';
import React, { useState } from 'react';

import { useAccountingPeriod } from '../../context/AccountingPeriodContext';
import MajorBookByAccount from './components/MajorBookByAccount';

const MajorBook: React.FC<{
  transactional?: boolean;
  startDate?: Date;
  endDate?: Date;
}> = ({
  transactional = false,
  startDate: propStartDate,
  endDate: propEndDate,
}) => {
  const { startDate, endDate, setPeriod } = useAccountingPeriod();
  const [buttons, setButtons] = useState<CustomButtonProps[]>([]);

  const periodSubtitle =
    startDate != null || endDate != null
      ? `Período: ${startDate ? formatDateString(startDate, 'dd/mm/yyyy') : ''} - ${endDate ? formatDateString(endDate, 'dd/mm/yyyy') : ''}`
      : undefined;

  const actionButtons: ActionButton[] = buttons
    .filter((button) => !button.customButton && !button.hidden)
    .map((button) => ({
      label: button.name ?? '',
      color: button.color,
      onClick: button.action,
      disabled: button.disabled,
      startIcon: button.startIcon,
      tooltip: button.hoverTooltip,
      loading: button.loading,
    }));

  const customFilters = buttons
    .filter((button) => button.customButton && !button.hidden)
    .map((button, index) => (
      <React.Fragment key={`custom-filter-${index}`}>
        {button.customButton}
      </React.Fragment>
    ));

  return (
    <div>
      <PageHeader.WithTitleAndActions
        iconType="calendar"
        title="Libro mayor"
        subtitle={periodSubtitle}
        actionButtons={actionButtons}
        filters={customFilters.length > 0 ? customFilters : undefined}
      />
      <MajorBookByAccount
        isActive={true}
        transactional={transactional}
        propStartDate={
          propStartDate ?? (startDate ? new Date(startDate) : undefined)
        }
        propEndDate={propEndDate ?? (endDate ? new Date(endDate) : undefined)}
        onButtonsReady={setButtons}
        onPeriodChange={setPeriod}
      />
    </div>
  );
};

export default MajorBook;
